module.exports = __webpack_public_path__ + "close.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/ui/preview-popup/assets/close.svg
// module id = 1177
// module chunks = 10